var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"125","height":"40","fill":"none"}},[_c('use',{attrs:{"xlink:href":"#brandLogo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }